<template>
  <v-sheet
    class=" d-flex draggale-item full-width"
    :class="{ 'draggale-item-active': isSelected, 'elevation-1': !readonly }"
    tile
  >
    <div
      class="flex-grow-0 draggable-handle clickable"
      v-if="!disabledDrag"
      :style="{
        background: item.color,
      }"
    >
      <div class="draggable-handle-icon d-flex justify-center align-center">
        <v-icon dark small>mdi-arrow-up-down</v-icon>
      </div>
    </div>
    <v-sheet
      class="draggale-item-info flex-grow-1 overflow-hidden"
      :class="{ 'pa-2': !readonly }"
      flat
      tile
      :min-height="readonly ? 0 : 65"
    >
      <slot />
    </v-sheet>
  </v-sheet>
</template>

<script>
export default {
  props: {
    isSelected: Boolean,
    disabledDrag: Boolean,
    item: { type: Object, default: () => ({}) },
    readonly: Boolean,
  },
}
</script>

<style scoped lang="scss">
.draggale-item {
  position: relative;
  .draggable-handle {
    background: var(--v-primary-lighten4);
  }
  .draggable-handle-icon {
    cursor: n-resize;
    width: 16px;
    height: 100%;
  }
}
.draggale-item-active {
  outline: 2px solid var(--v-primary-lighten2) !important;
}
</style>
<style scoped>
:deep(.v-slider.v-slider--horizontal) {
  min-height: 20px;
}
</style>
